import React from 'react';
import PropTypes from 'prop-types';

const Subtract = ({ fill = '' }) => (
  <svg
    width="16"
    height="3"
    viewBox="0 0 16 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4999 0.398438C15.1074 0.398438 15.5999 0.890924 15.5999 1.49844C15.5999 2.06545 15.1709 2.53226 14.6198 2.59198L14.4999 2.59844H1.4999C0.892389 2.59844 0.399902 2.10595 0.399902 1.49844C0.399902 0.931425 0.828913 0.464614 1.38005 0.404892L1.4999 0.398438H14.4999Z"
      fill={fill || 'white'}
    />
  </svg>
);

Subtract.propTypes = {
  fill: PropTypes.string,
};

export default Subtract;
